import React from 'react';
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    Cards,
    Steps,
    Popover,
    BreadcrumbGroup,
    Box,
    Link,
    SpaceBetween,
} from '@cloudscape-design/components';
import '../containers.css';
import downloadExtension from '../images/downloadedExtension.png';
import extenionInterface from '../images/extenionInterface.png';
import ViewMeetings from '../images/ViewMeetings.png';
import HelpPanel from "@cloudscape-design/components/help-panel";
import Icon from "@cloudscape-design/components/icon";
import { NavigationSide } from "./Navigation";


function GetStarted() {
    return (
        <AppLayout
          navigation={<NavigationSide activeHref="/getstarted"/>}
          content={<MainContent />}
          header={<PageHeader />}
          contentType="dashboard"
          toolsHide={true}
        />
    );
  }
  function Navigation({ activeHref }) {
    return (
      <SideNavigation
        activeHref={activeHref}
        header={{ text: 'AWS Eloquence', href: '/' }}
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings'},
          { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
          { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
        ]}
      />
    );
  }

  function MainContent() {
    //const navigate = useNavigate();
    return (
      <>
      <BreadcrumbGroup
      items={[
        { text: "Home", href: "/" },
        { text: "Get Started", href: "/getstarted" },
      ]}
      ariaLabel="Breadcrumbs"
    />
      <ContentLayout 
        defaultPadding
        // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
        headerVariant="high-contrast"
        maxContentWidth={2000}
        disableOverlap
        header={
            <Header 
              variant="h2" description="Download the Chrome Extension">Welcome to AWS Eloquence</Header>
          }
      >
    <ContentLayout
      defaultPadding
      disableOverlap
    >
      <Container>
          <HelpPanel
          footer={
            <div>
              <h3>
                Learn more{" "}
                <Icon name="external" size="inherit" />
              </h3>
              <ul>
                <li>
                  <a href="/documentation">Link to documentation</a>
                </li>
              </ul>
            </div>
          }
          header={<h2>Get started with Eloquence</h2>}
        >
          <div>
            <p>Learn how to transcribe your first call!</p>

            <h3>Quick start</h3>
            <ol>
              <li>Check out the getting started page on the wiki <Link href="https://w.amazon.com/bin/view/AmazonEloquence/Install">here</Link>!</li>
              <li>View post-call feedback in the <Link href="/meetings">console</Link></li>
            </ol>
          </div>
        </HelpPanel>
      </Container>
    </ContentLayout>
    </ContentLayout>
    </>
  );
}
  
  function ttt() {
      //const navigate = useNavigate();
      return (
        <Container
          header={
            <Header 
              variant="h2" description="Get Started">Welcome to AWS Eloquence</Header>
          }
        >
          <SpaceBetween size="l">
          
          </SpaceBetween>
          <div className="get-started-container">
      <h1>Installing the AWS Eloquence chrome extension</h1>
      <div className="instructions-container">
        <h2>Follow these steps:</h2>
        <ol className="instructions-list">
          <li>Navigate to <a href="#" className="link">INSERT WEBPAGE LINK</a></li>
          <li>Log into MidWay with your credentials</li>
          <li>Create and start your Chime call</li>
          <li>Enable the chrome extension in the top right</li>
            <img src={downloadExtension} alt="Data Report" style={{ width: '200px', height: 'auto' }}/>
          <li>Enable the meeting assistant</li>
            <img src={extenionInterface} alt="Data Report" style={{ width: '150px', height: 'auto' }}/>
          <li>Begin your call</li>
          <li>View post-call feedback in the console</li>
            <img src={ViewMeetings} alt="Data Report" style={{ width: '450px', height: 'auto' }}/>
        </ol>
      </div>
    </div>
    </Container>
    );
  }

  function PageHeader() {
    return (
      <Header
        variant="h1"
        actions={
          <div>
            {/* Add any header actions here */}
          </div>
        }
      >
        My Application
      </Header>
    );
  }
  export default GetStarted;
  
  
  
  
  
  
  
  
  
  
  
